import { Component, Input, OnInit } from '@angular/core';
import { EventsService, UtilService, VariablesService } from '../../../../shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-refer-friend',
  templateUrl: './refer-friend.component.html',
  styleUrls: ['./refer-friend.component.scss']
})
export class ReferFriendComponent implements OnInit {

  isSubmited = false;
  userData;

  constructor(
    public utilService: UtilService,
    private dialog: MatDialog,
    public _bottomSheet: MatBottomSheet,
    private variablesService: VariablesService,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.variablesService.userData.subscribe(res => {
      this.userData = res;
    });
  }
  // openPopup() {
  //   if (this.utilService.isMobile()) {
  //     this._bottomSheet.open(ReferFriendPopupComponent, {
  //       panelClass: 'refer-fr-bottomsheet'
  //     });
  //   } else {
  //     this.dialog.open(ReferFriendPopupComponent, {
  //       width: '468px',
  //       height: '493px',
  //       panelClass: 'refer-fr-popup'
  //     });
  //   }
  // }

  openPopup(template) {
    this.events.sendSystemEvent({
      eventName: 'refer_friend_clicked',
      info_1: this.userData?.id || '',
    }).subscribe(_=>_);
    this.variablesService.leadSubject = '(Refer a friend)-You received a new lead';
    this.variablesService.leadType = 'P - Talk to us (browse fundraisers)';
    this.variablesService.leadMailTo = 'leads.ketto@gmail.com';
    this.dialog.open(template, {
      maxWidth: '100vw',
      width: '519px',
      maxHeight: this.utilService.isMobile() ? '100vh' : 'auto',
      panelClass: 'talk-to-us-modal',
    });
  }
}
